module.exports = __webpack_public_path__ + "images/24f299bcc64a867ef8c0bb6fb55781e1-cs7.jpg";